export const getReviews = state => state.reviews.reviews;
export const selectIsLoading = state => state.reviews.isLoading;
export const selectError = state => state.reviews.error;
export const selectUserReview = state => state.reviews.userReview;